/** 期货前台展示代码（后台 API / Polygon 仍用原 symbol） */
const FUTURES_DISPLAY_SYMBOL: Record<string, string> = {
  GC: 'AUX',
}

/** 底部「交易」Tab 及 /trade 默认展示品种 */
export const DEFAULT_TRADE_DISPLAY_SYMBOL = FUTURES_DISPLAY_SYMBOL.GC

const FUTURES_API_SYMBOL: Record<string, string> = Object.fromEntries(
  Object.entries(FUTURES_DISPLAY_SYMBOL).map(([api, display]) => [display, api])
)

export function getFuturesDisplaySymbol(symbol: string): string {
  return FUTURES_DISPLAY_SYMBOL[symbol.toUpperCase()] ?? symbol
}

/** 将前台展示码还原为 API 代码，如 AUX -> GC */
export function resolveFuturesApiSymbol(symbol: string): string {
  const upper = symbol.toUpperCase()
  return FUTURES_API_SYMBOL[upper] ?? upper
}

export function getAssetDisplaySymbol(symbol: string, type?: string): string {
  const upper = symbol.toUpperCase()
  if (type === 'futures' || upper in FUTURES_DISPLAY_SYMBOL) {
    return getFuturesDisplaySymbol(symbol)
  }
  return symbol
}

/** 搜索时同时匹配展示码与 API 码 */
export function futuresSymbolMatchesQuery(symbol: string, type: string | undefined, query: string): boolean {
  const q = query.toLowerCase()
  if (!q) return true
  const upper = symbol.toUpperCase()
  if (upper.includes(q) || symbol.toLowerCase().includes(q)) return true
  if (type === 'futures') {
    const display = getFuturesDisplaySymbol(upper)
    if (display.toLowerCase().includes(q)) return true
  }
  return false
}
